import { createHourDropdownOptions } from '@acorn-portal/shared/src/utils/create-hour-dropdown-options';
import { TimeContext } from './get-current-time-context';

/**
 * Generates dynamic hour dropdown options based on the current time context.
 *
 * This function determines the minimum selectable hour based on whether the current
 * time allows for valid minute selections within the current hour, or if we need
 * to start from the next hour.
 *
 * @param timeContext - The current time context containing hour and minute information
 * @returns An array of hour dropdown options starting from the calculated minimum hour
 */
export const getHourOptionsFromNow = (timeContext: TimeContext) => {
	const { currentHour, nextValidMinute } = timeContext;
	// Check if we can still select valid minutes within the current hour
	// and ensure we haven't reached the maximum hour (23)
	const insideValidWindow = nextValidMinute < 60 && currentHour < 23;
	const nextHour = currentHour + 1;

	// Determine the minimum selectable hour:
	// - If within valid window: start from current hour
	// - Otherwise:  start from next hour (current selections are in the past)
	const minHour = insideValidWindow ? currentHour : nextHour;

	return createHourDropdownOptions(minHour);
};
